import { DTOError } from 'src/error/errors/DTOError';
import type {
  PackageUpsaleExtraOptionType,
  PackageUpsaleOptionType,
  PackageUpsaleOptionsStateType,
} from './types';

const packageUpsaleExtraOptionTypeDTO = (
  data: unknown,
): PackageUpsaleExtraOptionType => {
  if (
    data &&
    typeof data === 'object' &&
    'hashsum' in data &&
    typeof data.hashsum === 'string' &&
    'description' in data &&
    typeof data.description === 'string' &&
    'price' in data &&
    (typeof data.price === 'string' || typeof data.price === 'number')
  ) {
    return {
      hashsum: data.hashsum,
      description: data.description,
      price: data.price,
      variant:
        'variant' in data && typeof data.variant === 'string'
          ? data.variant
          : undefined,
    };
  }
  throw new DTOError('packageUpsaleExtraOptionTypeDTO', data);
};

const packageUpsaleOptionTypeDTO = (data: unknown): PackageUpsaleOptionType => {
  if (
    data &&
    typeof data === 'object' &&
    'id' in data &&
    (typeof data.id === 'number' || typeof data.id === 'string') &&
    'service_type' in data &&
    typeof data.service_type === 'string' &&
    'options' in data &&
    Array.isArray(data.options) &&
    'hierarchy' in data &&
    typeof data.hierarchy === 'boolean'
  ) {
    return {
      id: data.id,
      service_type: data.service_type,
      options: data.options.map((option) =>
        packageUpsaleExtraOptionTypeDTO(option),
      ),
      hierarchy: data.hierarchy,
      title:
        'title' in data && typeof data.title === 'string'
          ? data.title
          : undefined,
      tooltip:
        'tooltip' in data && typeof data.tooltip === 'string'
          ? data.tooltip
          : undefined,
    };
  }
  throw new DTOError('PackageUpsaleOptionTypeDTO', data);
};

export const packageUpsaleOptionsStateTypeDTO = (
  data: unknown,
): PackageUpsaleOptionsStateType => {
  if (
    data &&
    typeof data === 'object' &&
    'extras' in data &&
    Array.isArray(data.extras)
  ) {
    const parseData = data.extras.map((extra) =>
      packageUpsaleOptionTypeDTO(extra),
    );

    return {
      transferOptions: parseData.filter(
        ({ service_type }) => service_type === 'transfer',
      ),
      extraOptions: parseData.filter(
        ({ service_type }) =>
          service_type === 'other' || service_type === 'baggage',
      ),
      chosenOptions: [],
    };
  }
  return {
    transferOptions: [],
    extraOptions: [],
    chosenOptions: [],
  };
};
